import { SET_CURRENT_NEWS } from "./newsConstants";
import { setValue } from "../../lib/immutable_wrapper";

const initialState = {
    currentNews: [],
};

export function news(state = initialState, action) {
    switch (action.type) {
        case SET_CURRENT_NEWS:
            return setValue(state, ["currentNews"], action.currentNews);
        default:
            return state;
    }
}
